import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            探索学习主题
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            五大核心主题板块，系统覆盖青少年性教育的方方面面，总有一个板块适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                    <i className={`${cat.icon} text-lg text-primary-600`} />
                  </div>
                  <h3 className="font-heading font-semibold text-base text-foreground-950">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-400">
                    {cat.articleCount} 篇文章
                  </span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap">
                    查看全部
                    <i className="ri-arrow-right-s-line" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}